import React from "react";
import { Select } from "antd";

export default function TtSelect(props) {
  const { component, currentConfig, handleChange, toIntIf, values } = props;

  if (component.colormap) {
    return (
      <Select
        style={{ width: "100%" }}
        placeholder={`Seleziona ...`}
        size="large"
        options={component.permittedValues.map((v, k) => {
          return {
            label: (
              <div
                className="color-option"
                style={{ display: "flex", alignItems: "center" }}
              >
                {" "}
                <span
                  className="color-swatch"
                  style={{
                    backgroundColor: component.colormap[k],
                    display: "inline-block",
                    width: 25,
                    height: 25,
                    margin: 5,
                    marginRight: 20,
                  }}
                ></span>
                {v}
              </div>
            ),
            value: v,
            color: component.colormap[k],
          };
        })}
        optionRender={(option) => {
          console.log(option);
          return (
            <div>
              <span>{option.data.color}</span>
              {option.data.description}
            </div>
          );
        }}
        value={values[component.name] ? values[component.name] : null}
        name={component.name}
        onChange={(value) => {
          handleChange({ [component.name]: toIntIf(value) });
        }}
      />
    );
  }

  return (
    <Select
      style={{ width: "100%" }}
      placeholder={`Seleziona ...`}
      size="large"
      options={component.permittedValues.map((v, k) => {
        console.log(k, v);
        if (typeof v === "object" && v !== null) {
          return {
            label: v.description,
            value: v.code,
            file: v.file ? v.file : false,
          };
        }

        return {
          label: v,
          value: v,
        };
      })}
      value={values[component.name] ? values[component.name] : null}
      name={component.name}
      onChange={(value) => {
        handleChange({ [component.name]: toIntIf(value) });
      }}
    />
  );
}
